export function getLocale() {
  if (typeof navigator === 'undefined') {
    return 'en'
  }
  return navigator.languages ? navigator.languages[0] : navigator.language
}

export default getLocale()
